import React from 'react';
import { IconButton } from '@mui/material';
import { useTheme } from './themeContext';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Brightness4Icon from '@mui/icons-material/Brightness4';

const ThemeToggleButton = () => {
  const { toggleTheme } = useTheme();
  const [isDarkMode, setIsDarkMode] = React.useState(false);

  const handleToggle = () => {
    toggleTheme();
    setIsDarkMode(prev => !prev); // Toggle the state
  };

  return (
    <IconButton onClick={handleToggle} color="inherit">
      {isDarkMode ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
};

export default ThemeToggleButton;
